module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_library.js
// module id = 36
// module chunks = 1 2